import {calculateMovieProgress} from "../web/v1/functions";

export default class ProgressBar {
    constructor(duration, resume_time) {
        this.duration = duration;
        this.resume_time = resume_time;
    }

    element() {
        if ( this.canCalculateProgress() ) {
            let movie_progress = calculateMovieProgress( this.duration, this.resume_time );
            if( movie_progress && movie_progress > 0 ) {
                let progress_bar = document.createElement('div');
                progress_bar.classList.add('progress-bar');
                progress_bar.setAttribute('role',"progressbar");
                progress_bar.style.width = `${movie_progress}%`;
                progress_bar.setAttribute('aria-valuenow', `${movie_progress}`);
                progress_bar.setAttribute('aria-valuemin', '0');
                progress_bar.setAttribute('aria-valuemax', '100');

                let  progress = document.createElement('div');
                progress.classList.add('progress');
                progress.appendChild( progress_bar );

                return progress;
            }
        }

        return null;
    }
    canCalculateProgress() {
        return this.duration && this.resume_time && this.resume_time > 0;
    }

}
